import { render, staticRenderFns } from "./rejection.vue?vue&type=template&id=0f3b42f5&scoped=true&"
import script from "./rejection.vue?vue&type=script&lang=js&"
export * from "./rejection.vue?vue&type=script&lang=js&"
import style0 from "./rejection.vue?vue&type=style&index=0&id=0f3b42f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b42f5",
  null
  
)

export default component.exports